export type TitleVariant = "oneRow" | "twoRow" | "threeRow" | "fourRow";

const NBSP = " ";
const pickVariant = (title: string): TitleVariant => {
  const length = title.length;
  if (length <= 10) return "oneRow";
  if (length <= 18) return "twoRow";
  if (length <= 26) return "threeRow";
  return "fourRow";
};

// When a title ends in a short trailing word of 1 or 2 characters
// ("CHAOS CREW 3", "SUPER 99"), swap the preceding space for a non-breaking
// space so the browser cannot wrap that short word onto its own line.
const preventTrailingShortOrphan = (title: string) =>
  title.replace(/ (\w{1,2})$/, `${NBSP}$1`);

const computeTitle = (name: string) => {
  const trimmed = name.trim();
  return {
    displayTitle: preventTrailingShortOrphan(trimmed),
    variant: pickVariant(trimmed),
  };
};

export default computeTitle;
